/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/quotes */
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { FCM } from "@capacitor-community/fcm";
import { Token, PushNotifications, PushNotificationSchema, ActionPerformed } from '@capacitor/push-notifications';
import { ToastController } from "@ionic/angular";
import { AppInsightsService } from "./app-insights.service";
import { DataService } from "./data";

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(
    private toast: ToastController,
    private router: Router,
    private dataService: DataService,
    private log: AppInsightsService
  ) { }

  async registerPushNotifications() {
    this.registerPushEventHandlers();
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
      console.warn('Notifications denied by user.');
      return;
    }

    await PushNotifications.register();

    // Get FCM token instead the APN one returned by Capacitor
    try {
      const fcm = await FCM.getToken();
      console.log('PUSH TOKEN', fcm);

      try {
        //TODO: save to db?
        await this.dataService.registerUserForNotifications(fcm.token);
      } catch (err) {
        console.error('API NOTIFICATIONS ERROR', err);
        this.log.logException(err);
      }

      // Enable the auto initialization of the library
      await FCM.setAutoInit({ enabled: true });

      // Check the auto initialization status
      const r = await FCM.isAutoInitEnabled();
      console.log("Auto init is " + (r.enabled ? "enabled" : "disabled"));
    } catch (err) {
      console.error('PUSH NOTIFICATION REGISTER FAIL', err);
      this.log.logException(err);
    }

    // Remove FCM instance
    // FCM.deleteInstance()
    // .then(() => alert(`Token deleted`))
    // .catch((err) => console.log(err));
  }

  private registerPushEventHandlers() {
    PushNotifications.addListener('registration', async (token: Token) => {
      console.log('Push registration success, token: ', token);
    });

    PushNotifications.addListener('registrationError', (error: any) => {
      console.error('Push registration failed: ', error);
    });

    PushNotifications.addListener('pushNotificationReceived', (notification: PushNotificationSchema) => {
      console.log('Push received: ', notification);

      // this.toast.create({
      //   message: `${notification.title} ${notification.body}`,
      //   duration: 3000,
      //   color: 'primary',
      //   position: 'bottom',
      // }).then(toast => toast.present());
    });

    PushNotifications.addListener('pushNotificationActionPerformed', async (action: ActionPerformed) => {
      console.log('Push action performed: ', action);
      const notificationData = action.notification.data;
      if (action.actionId == 'tap' && notificationData) {
        if (notificationData.appRoute) {
          //parse query params
          let queryParams = '';
          if (notificationData.rodeoId) {

            queryParams += `rodeoId=${notificationData.rodeoId}&`;
          }
          if (notificationData.registrationId) {
            queryParams += `registrationId=${notificationData.registrationId}&`;
          }

          //navigate to page
          let url = 'tabs/' + notificationData.appRoute;
          if (queryParams != '') {
            url += `?${queryParams}`;
          }
          
          await this.router.navigateByUrl(url);
        }
      }
    });
  }

  registerTopics(topic: string) {
    // now you can subscribe to a specific topic
    FCM.subscribeTo({ topic })
      .then((r) => alert(`subscribed to topic`))
      .catch((err) => console.log(err));
  }

  unsubscribeTopic(topic: string) {
    // Unsubscribe from a specific topic
    FCM.unsubscribeFrom({ topic })
      .then(() => alert(`unsubscribed from topic`))
      .catch((err) => console.log(err));
  }
}
